module.exports = __webpack_public_path__ + "static/media/one.f15b96a1.svg";